import React from 'react';
import { Button } from 'semantic-ui-react';

const SocialButtons = () => (
    <div>
        <Button circular inverted size='large' href='https://www.linkedin.com/in/christopher-jaeger/' icon='linkedin' />
        <Button circular inverted size='large' href='https://twitter.com/seejaeger' icon='twitter' />
        <Button circular inverted size='large' href='https://stackoverflow.com/users/2561435/jaegs' icon='stack overflow' />
        <Button circular inverted size='large' href='https://github.com/jaegz' icon='github' />
        <Button circular inverted size='large' href='https://codepen.io/jaegs/' icon='codepen' />
    </div>
)

export default SocialButtons